import { render } from "./DynamicButton.vue?vue&type=template&id=adcb15ae&ts=true"
import script from "./DynamicButton.vue?vue&type=script&lang=ts"
export * from "./DynamicButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "adcb15ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('adcb15ae', __exports__)) {
    api.reload('adcb15ae', __exports__)
  }
  
  module.hot.accept("./DynamicButton.vue?vue&type=template&id=adcb15ae&ts=true", () => {
    api.rerender('adcb15ae', render)
  })

}


export default __exports__